import { graphql } from '@/gql';
import type { AffiliatesQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedAffiliateTypeResponse } from '@/models/affiliate';

export const fetchAffiliates = async ({
  isDisabled,
  search,
  pagination,
  codeName,
  orderBy,
  sortType,
  extension,
}: AffiliatesQueryVariables): Promise<PaginatedAffiliateTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query Affiliates(
        $isDisabled: Boolean
        $search: String
        $codeName: String
        $extension: Float
        $orderBy: String
        $sortType: String
        $pagination: PaginationInputType
      ) {
        affiliates(
          isDisabled: $isDisabled
          search: $search
          codeName: $codeName
          extension: $extension
          orderBy: $orderBy
          sortType: $sortType
          pagination: $pagination
        ) {
          count
          rows {
            id
            name
            codeName
            extension
            promoCode
            phoneNumber
            gogoNumber
            email
            streetAddress
            streetAddress2
            city
            state
            zip
            country
            latitude
            longitude
            currency
            timeZone
            description
            isDisabled
            numberOfCallers
            logoUrl
          }
        }
      }
    `),
    variables: {
      isDisabled,
      search,
      codeName,
      extension,
      orderBy,
      sortType,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.affiliates;
};
